import type { PluginWebManifest } from '@reflex/plugin-api/web';

export const pagerdutyWeb: PluginWebManifest = {
  orgSetupComponent: {
    componentPath: '@reflex/plugin-pagerduty/web/PagerDutyPage',
    label: 'Add a PagerDuty API key to connect your account.',
  },
};
